import { setupWorker } from 'msw/browser'
import { HttpNetworkFrame } from 'msw/experimental'
import { handlers } from 'prove-common/mocks'

export const worker = setupWorker(...handlers)

export const startWorker = () =>
  worker.start({
    onUnhandledFrame: ({ frame, defaults }) => {
      if (import.meta.env.MODE !== 'test') return
      if (
        frame instanceof HttpNetworkFrame &&
        frame.data.request.url.includes('/api/')
      ) {
        defaults.error()
        throw new Error(
          `Unhandled API request in proveadmin test: ${frame.data.request.url}`
        )
      }
      // In test mode, allow normal app boot assets but fail any other missing
      // mock instead of silently proxying API calls to a developer backend.
      defaults.warn()
    }
  })
